import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import "./kycGuideStyles.css";
import styles from "../CsplModal/Modal.module.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslation } from "react-i18next";
import { Form, Formik } from "formik";
import { FormikPatchTouched } from "../../Utils/FormikPatchTouched";
import CsplTermsAndConditions from "../CsplControls/CsplTermsAndConditions/CsplTermsAndConditions";
import * as Yup from "yup";
import { SessionKeyEnum } from "../../Enumeration/SessionKeyEnum";
import KycGuideResource from "../Resources/KycGuideResource/KycGuideResource";

function KycGuideModal(props) {
  const { t } = useTranslation("common");
  const [show, setShow] = useState();
  const [acceptTermsAndConditions] = KycGuideResource();
  const kycGuideValidationSchema = Yup.object({
    kycGuideDTO: Yup.object().shape({
      content: Yup.string().nullable(),
      termsAndConditionsAccepted: Yup.boolean()
        .nullable()
        .required(t("kycGuide.termsAndConditionRequiredText"))
        .oneOf([true], t("kycGuide.termsAndConditionRequiredText")),
    }),
  });

  useEffect(() => {
    setShow(props.isTacChecked);
  }, [props.isTacChecked]);

  function HandleCloseCall(values, actions) {
    acceptTermsAndConditions(sessionStorage.getItem(SessionKeyEnum.AppKey)).then(
      (res) => {
        setShow(false);
        props.setischecked(false);
        actions.setTouched({});
        actions.setSubmitting(false);
        props.getAutoTriggerConfirmation(true);
      },
      (error) => {
        console.log(error);
        actions.setSubmitting(false);
      }
    );
  }

  return (
    <section>
      <Formik
        initialValues={{ kycGuideDTO: { termsAndConditionsAccepted: false } }}
        validationSchema={kycGuideValidationSchema}
        onSubmit={HandleCloseCall}
        enableReinitialize={true}
      >
        {/* model  */}
        {({ isSubmitting, errors, values, handleChange }) => (
          <Form id="kycGuideForm" autoComplete="off">
            <FormikPatchTouched />

            <Modal
              scrollable={true}
              show={show}
              backdrop="static"
              className="modal_KycGuide modal_mainbody "
              size="lg"
             /*  fullscreen="lg-down" */
              aria-labelledby="contained-modal-title-vcenter"
      centered
            >
              <Modal.Header className={styles.modaltitle}>
                <Modal.Title className="title_font">
                  {t("kycGuide.title")}
                </Modal.Title>
              </Modal.Header>

              <Modal.Body className="modalbody">
                <div className="modal_subbody">
                  <div className="mb-3">
                    <h4 className="header mb-2"> Understanding Tabs </h4>
                    <div className="tab_btns">
                      <button className="btn_completed">
                        {" "}
                        Completed tabs{" "}
                      </button>
                      <button className="btn_current"> Current tab </button>
                      <button className="btn_yet">
                        {" "}
                        Yet to complete tabs{" "}
                      </button>
                    </div>
                  </div>

                  <div className="note">
                    <h6 className="note_header"> Note </h6>
                    <p className="note_content">
                      {" "}
                      Green tick <span className="note_icon grntick">
                       
                      </span>{" "}
                      denotes the particular upload/step/process is been
                      successfully done/completed.{" "}
                    </p>
                  </div>
                  {/* checking the terms & condition */}

                  <CsplTermsAndConditions
                    description={<>{t("kycGuide.termsAndConditionsText")}</>}
                    name="kycGuideDTO.termsAndConditionsAccepted"
                    label={"termsAndCondition.agreeTermsAndConditionText"}
                    showlinktext={false}
                    noScroll={true}
                    darkTheme={true}
                  ></CsplTermsAndConditions>
                  <br />
                  <br />
                </div>
              </Modal.Body>

              <Modal.Footer>
                <Button
                  className="btn shadow-none ok_btn cursor_pointer font-size-13"
                  disabled={isSubmitting}
                  form="kycGuideForm"
                  type="submit"
                >
                  {t("form.gotIt")}
                </Button>
              </Modal.Footer>
            </Modal>
          </Form>
        )}
      </Formik>
    </section>
  );
}

export default KycGuideModal;
